import * as React from 'react';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './BackButtonDesktop.css';

export interface IBackButtonDesktopProps {
  title: string;
  url: string;
}

export const BackButtonDesktop: React.FC<IBackButtonDesktopProps> = ({ title, url }) => {
  return (
    <a data-name="BackButtonDesktop" className={styles['link']} href={url} title={title}>
      <IconActionChevronLeft16 color="current_color" />
      <span className={styles['title']}>{title}</span>
    </a>
  );
};
